import React from 'react';
import { $EmptySearch, $ImgContainer } from './styles';
import empty from '../assets/icons/emptySearch.svg';
import { Title } from '../';
export const EmptySearch = () => (React.createElement($EmptySearch, null,
    React.createElement($ImgContainer, null,
        React.createElement("img", { src: empty, alt: 'empty' })),
    React.createElement(Title, { alternate: true }, "There are no results matching your search")));
